(function($) {
	PortalMap.prototype.initSitesearchList = function(complete, points)  {
		if(complete) {
			var portalMap = this;
			portalMap.mysite = portalMap.groups.mysite && portalMap.groups.mysite.markers[0] || null;
			if(portalMap.mysite) {
			    portalMap.mysite.neighbour = false;
				var threshold = gm.meterPerPixel(portalMap.mysite.position.lat(), (portalMap.maxZoom||16)-3)*6/1000;
				portalMap.neighbours = portalMap.groups.site.markers.filter(function(marker) { return marker.neighbour = gm.geoDistance(portalMap.mysite.position, marker.position) <= threshold })
					.map(function(marker) { marker.setIcon(gm.iconOptions(gm.icons.site2)); return marker });
			}
			if(!portalMap.original) {
				portalMap.original = { sites: points.filter(function(point) { return point.group=='site' }), baseUrl: this.baseUrl || this.dataSource.url };
				portalMap.points = (portalMap.points||[]).concat(portalMap.original.sites);
				portalMap.groups.site.keep = true;
				$(document).ready(function() {
					var list = portalMap.original.sites.map(function(detail) { return $.extend({}, detail, { id: 'site-'+detail.site_id, value: detail.site_id, lc_id: detail.site_id, label: detail.name }) }),
						$sitesearch = $('input.gm-sitesearch[data-map="'+portalMap.id+'"]').autocomplete("option", "list", list),
						$refine = $sitesearch.filter(function(index) { return portalMap.sitesearch == this.id || (index==0 && portalMap.sitesearch==true) });
					if($refine.length) {
						$refine
							.on('sitesearch.assign', function(event, item, mode) {
								if(item) {
									var points = portalMap.mysite ? portalMap.original.sites.filter(function(detail) { return detail.site_id == portalMap.mysite.site_id }) : [], marker = portalMap.markerById[item.id];
									if(marker) {
										points.push($.extend({}, marker.detail, { icon: 'mysite', 'group': 'mysite', 'zIndex': 1 }));
									}
									portalMap.restart({ points: points, dataSource: { url: portalMap.original.baseUrl + '/' + item.value }, ignorePoints: true });
								}
								else {
									portalMap.restart({ points: portalMap.original.sites, dataSource: { url: portalMap.original.baseUrl }, ignorePoints: true });
								}
							})
							.on('sitesearch.fetch', function(event, item) {
								var list = $(this).autocomplete('option', 'list') || [];
								if(typeof item == 'number') item = list.find(function(entry) { return entry.site_id==item });
								if(typeof item == 'string') item = list.find(function(entry) { return entry.id==item });
								var ac = $(this).data('ui-autocomplete');
								if(ac) ac._trigger('select', 'autocompleteselect', { item: item });
							});
						$(portalMap.map.getDiv()).addClass('has-sitesearch')
							.on('click', '.site-name[data-id]', function(e) { $refine.trigger('sitesearch.fetch', [$(this).attr('data-id')] ) });
						if(portalMap.autosearch) {
							$refine.trigger('sitesearch.fetch', [+portalMap.autosearch]);
						}
					}
					$sitesearch.each(function() {
						var mode = 'autocomplete';
						$('select[name$="-lc_id"][data-search="'+this.id+'"]').each(function() {
							var $dropdown = $(this);
							list.map(function(item) { $dropdown.append($('<option>', { value: item.lc_id }).text(item.label)) })
							$dropdown.val(null);
							if(list.length <= 20) mode = 'dropdown';
							$dropdown.change(function(e) { if(e.originalEvent) $refine.trigger('sitesearch.fetch', [+this.value]) })
						})
						$(this).closest('.select-site').attr('data-mode', mode).find('.mode-autocomplete input').prop('required', mode=='autocomplete');
					});
					if(list.length<=1)
						$sitesearch.each(function() {
							$(this).data('ui-autocomplete')._trigger('select', 'autocompleteselect', { item: list[0] });
							$(this).closest('.select-site').attr('data-mode', 'default');
						});
					if (list.length > 8) $('#location').addClass('search');
				});
			}
		}
	};
	window.onSiteMarkerClick = function onSiteMarkerClick(self) {
		if(self.sitesearch) $('#'+self.sitesearch).trigger('sitesearch.fetch', [this.id]);
	};
})(jQuery);
